import { withDb } from '../data/idb.js';
import { OFFLINE_MODE_ENABLED, escapeHtml } from '../core/config.js';

/**
 * Attendance page (checkin/history): online, the Livewire component (server); offline with the offline mode, the
 * badges of the device instead (is_allowed and scan_count of the server, local scans not yet synced included).
 */
const rootEl = document.getElementById('checkin-attendance');

export const ATTENDANCE = {
    async init() {
        if (!rootEl || !OFFLINE_MODE_ENABLED) return;

        const update = () => this.update();
        window.addEventListener('online', update);
        window.addEventListener('offline', update);
        await this.update();
    },

    async update() {
        const onlineEl = rootEl.querySelector('.pg-attendance-online');
        const localEl = rootEl.querySelector('#checkin-attendance-local');
        if (!onlineEl || !localEl) return;

        if (navigator.onLine) {
            onlineEl.hidden = false;
            localEl.hidden = true;
            return;
        }

        let badges = [];
        try {
            badges = await withDb(db => db.getAll('badges'));
        } catch (e) {
            // No local data: the server content stays (last state loaded)
            return;
        }
        if (!Array.isArray(badges)) return;

        localEl.innerHTML = this.render(badges);
        onlineEl.hidden = true;
        localEl.hidden = false;
    },

    render(badges) {
        const label = name => rootEl.dataset[`label${name}`] || '';
        const byName = (a, b) => String(a.name || '').localeCompare(String(b.name || ''));
        const allowed = badges.filter(b => b.is_allowed);
        const scanned = allowed.filter(b => (b.scan_count || 0) > 0).sort(byName);
        const unscanned = allowed.filter(b => !(b.scan_count > 0)).sort(byName);
        const percent = allowed.length ? Math.floor(scanned.length * 100 / allowed.length) : 0;

        const rows = (list, empty) => list.length
            ? `<ul class="pg-rows">${list.map(b => `
                <li class="pg-row">
                    <div class="pg-row-main">
                        <div class="pg-row-title">${escapeHtml(b.name)}</div>
                        ${b.company ? `<div class="pg-row-meta">${escapeHtml(b.company)}</div>` : ''}
                    </div>
                    ${b.scan_count > 0 ? `<span class="pg-chip">${escapeHtml(b.scan_count)}</span>` : ''}
                </li>`).join('')}</ul>`
            : `<p class="pg-attendance-empty">${escapeHtml(empty)}</p>`;

        return `
            <div class="pg-attendance">
                <p class="pg-attendance-offline-note"><i class="bi bi-wifi-off" aria-hidden="true"></i>${escapeHtml(label('Offline'))}</p>
                <div class="pg-attendance-stats">
                    <div class="pg-attendance-stat"><span class="pg-attendance-value">${allowed.length}</span><span class="pg-attendance-label">${escapeHtml(label('Allowed'))}</span></div>
                    <div class="pg-attendance-stat is-scanned"><span class="pg-attendance-value">${scanned.length}</span><span class="pg-attendance-label">${escapeHtml(label('Scanned'))}</span></div>
                    <div class="pg-attendance-stat"><span class="pg-attendance-value">${unscanned.length}</span><span class="pg-attendance-label">${escapeHtml(label('Unscanned'))}</span></div>
                </div>
                <div class="pg-attendance-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}"><span style="width: ${percent}%"></span></div>
                <p class="pg-attendance-progress-label">${escapeHtml(label('Progress').replace(':percent', percent))}</p>
                <h2 class="pg-attendance-heading">${escapeHtml(label('Unscanned'))} <span class="pg-attendance-count">${unscanned.length}</span></h2>
                <section class="pg-card pg-attendance-list">${rows(unscanned, label('EmptyUnscanned'))}</section>
                <h2 class="pg-attendance-heading">${escapeHtml(label('Scanned'))} <span class="pg-attendance-count">${scanned.length}</span></h2>
                <section class="pg-card pg-attendance-list">${rows(scanned, label('EmptyScanned'))}</section>
            </div>`;
    },
};
